import React, { useEffect, useState } from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import TrustedMarquee from "../components/site/TrustedMarquee";
import Services from "../components/site/Services";
import WebDesignPackages from "../components/site/WebDesignPackages";
import Packages from "../components/site/Packages";
import Bundles from "../components/site/Bundles";
import WorkShowcase from "../components/site/WorkShowcase";
import About from "../components/site/About";
import Process from "../components/site/Process";
import TechStack from "../components/site/TechStack";
import Testimonials from "../components/site/Testimonials";
import AreasServed from "../components/site/AreasServed";
import FAQ from "../components/site/FAQ";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Landing() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id) setTimeout(() => document.getElementById(id)?.scrollIntoView(), 100);
  }, []);

  return (
    <div className="relative bg-white text-slate-900">
      <Navbar />
      <main>
        <Hero />
        <TrustedMarquee />
        <Services />
        <WebDesignPackages />
        <Packages />
        <Bundles />
        <WorkShowcase />
        <About />
        <Process />
        <TechStack />
        <Testimonials />
        <AreasServed />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
